import { render } from "./VideoModel.vue?vue&type=template&id=6e3c1af2"
import script from "./VideoModel.vue?vue&type=script&lang=js"
export * from "./VideoModel.vue?vue&type=script&lang=js"

import "./VideoModel.vue?vue&type=style&index=0&id=6e3c1af2&lang=scss"

import exportComponent from "C:\\Projects\\KneeLeadNew\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__